import { TableHeader } from 'components/UI/V3/Table/Header/TableHeader';
import { TableHeaderCell } from 'components/UI/V3/Table/HeaderCell/TableHeaderCell';
import Checkbox from 'components/UI/V3/Forms/Checkbox';
import { Sort } from '@spike/model';
import { FunctionComponent } from 'react';
import HeaderTableColumn from './HeaderTableColumn';
import { appointmentSortColumns } from './groomingSort';
import styles from './TrainingHeaderTable.module.scss';

interface TrainingHeaderTableProps {
    sort: Sort | null;
    onSort?: (sort: Sort) => void;
    allSelected?: boolean;
    onToggleSelectAll?: (checked: boolean) => void;
}

export const TrainingHeaderTable: FunctionComponent<TrainingHeaderTableProps> = props => {
    return (
        <TableHeader>
            {props.onToggleSelectAll && (
                <TableHeaderCell className={styles.checkboxCell}>
                    <Checkbox
                        checked={props.allSelected}
                        onChange={props.onToggleSelectAll}
                    />
                </TableHeaderCell>
            )}
            <HeaderTableColumn
                sortColumn={appointmentSortColumns.client}
                selectedSort={props.sort}
                onServerSort={props.onSort}
            >
                Client Name
            </HeaderTableColumn>
            <HeaderTableColumn
                sortColumn={appointmentSortColumns.pet}
                selectedSort={props.sort}
                onServerSort={props.onSort}
            >
                Pet Name
            </HeaderTableColumn>
            <HeaderTableColumn
                sortColumn={appointmentSortColumns.service}
                selectedSort={props.sort}
                onServerSort={props.onSort}
            >
                Service
            </HeaderTableColumn>
            <HeaderTableColumn
                sortColumn={appointmentSortColumns.staff}
                selectedSort={props.sort}
                onServerSort={props.onSort}
            >
                Staff
            </HeaderTableColumn>
            <HeaderTableColumn
                sortColumn={appointmentSortColumns.bookedAt}
                selectedSort={props.sort}
                onServerSort={props.onSort}
            >
                Date & Time
            </HeaderTableColumn>
            <HeaderTableColumn
                sortColumn={appointmentSortColumns.total}
                selectedSort={props.sort}
                onServerSort={props.onSort}
            >
                Total
            </HeaderTableColumn>
        </TableHeader>
    );
};

export default TrainingHeaderTable;
